export enum ComparisonTabs {
    PRICE = 'price',
    BASE_UNITS = 'base_units',
    WALL_UNITS = 'wall_units',
    GENERAL = 'general'
};
